import { toast, ToastContainer } from 'react-toastify';

import useTitle from './hooks/useTitle';
import AppRoutes from 'routes/AppRoutes';

import CacheBuster from 'react-cache-buster';
import packageInfo from '../package.json';

import UpdatingVersion from 'components/common/UpdatingVersion/UpdatingVersion';
import MLCustomIcon from 'components/common/CustomIcon';

import ErrorBoundary from 'components/errorBoundary/ErrorBoundary';

import awsconfig from '_actions/aws-config';
import { Amplify } from 'aws-amplify';

function App() {
  useTitle('Trailsafe');
  console.log('🚀 ~ App ~ awsconfig:', awsconfig);
  Amplify.configure(awsconfig);

  const { version } = packageInfo;
  console.log('🚀 ~ version:', version);

  const isProduction = process.env.REACT_APP_NODE_ENV !== 'local';
  return (
    <CacheBuster
      currentVersion={version}
      isEnabled={isProduction} //If false, the library is disabled.
      isVerboseMode={true} //If true, the library writes verbose logs to console.
      loadingComponent={<UpdatingVersion />} //If not pass, nothing appears at the time of new version check.
      metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server.
    >
      <ErrorBoundary customMessage="Something went wrong for App">
        <ToastContainer
          icon={({ type }) => {
            switch (type) {
              case 'success':
                return <MLCustomIcon iconName="Success-toast" />;
              case 'error':
                return <MLCustomIcon iconName="Error-toast" />;
              case 'warning':
                return <MLCustomIcon iconName="Warning-toast" />;
              case 'info':
                return <MLCustomIcon iconName="Info-toast" />;
              default:
                return undefined;
            }
          }}
          closeButton={
            <span
              className="close-icon cursor-pointer"
              onClick={() => toast.dismiss()}
            >
              <MLCustomIcon iconName="Cross" height="14px" width="14px" />
            </span>
          }
        />
        <AppRoutes />
      </ErrorBoundary>
    </CacheBuster>
  );
}

export default App;
